module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stream-browserify/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 412
// module chunks = 2